/**
 * @file
 * A JavaScript file for the truncate list js.
 *
 * @copyright Copyright 2025 Palantir.net
 */

document.addEventListener('DOMContentLoaded', () => {
  const locationServices = document.querySelectorAll('.truncate-list');

  // Helper: throttle function
  function throttle(fn, wait) {
    let lastTime = 0;
    let timeout;
    return function(...args) {
      const now = Date.now();
      if (now - lastTime >= wait) {
        lastTime = now;
        fn.apply(this, args);
      } else {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          lastTime = Date.now();
          fn.apply(this, args);
        }, wait - (now - lastTime));
      }
    };
  }

  // Helper: get how many items to show based on viewport
  function getVisibleCount() {
    return window.innerWidth > 600 ? 12 : 5;
  }

  // Store state for each list
  const lists = [];

  locationServices.forEach(service => {
    const listItems = service.querySelectorAll('ul > li, ol > li');
    if (listItems.length > 5) {
      // Add a button to show all after the list if not already present
      let button = service.querySelector('.truncate-list__button');
      if (!button) {
        button = document.createElement('button');
        button.className = 'button--secondary button--small truncate-list__button button--down-arrow show';
        button.textContent = 'See More';
        service.appendChild(button);
      }

      const listState = {
        service,
        listItems,
        button,
        expanded: false
      };
      lists.push(listState);

      button.addEventListener('click', function(e) {
        e.preventDefault();
        listState.expanded = !listState.expanded;
        updateListDisplay(listState);
      });
      // Initial display
      updateListDisplay(listState);
    }
  });

  function updateListDisplay(listState) {
    const { listItems, button, expanded } = listState;
    const visibleCount = getVisibleCount();
    if (expanded) {
      button.classList.remove('show');
      button.classList.add('hide');
      button.textContent = 'See Less';
      listItems.forEach(li => {
        li.style.display = '';
      });
    } else {
      button.classList.remove('hide');
      button.classList.add('show');
      button.textContent = 'See More';
      listItems.forEach((li, idx) => {
        li.style.display = idx < visibleCount ? '' : 'none';
      });
    }
    // Show button only if there are more items than visibleCount
    if (listItems.length > visibleCount) {
      button.style.display = '';
    } else {
      button.style.display = 'none';
    }
  }

  // Throttled resize handler
  const handleResize = throttle(() => {
    lists.forEach(listState => {
      // Only update display if not expanded
      if (!listState.expanded) {
        updateListDisplay(listState);
      }
    });
  }, 100);

  window.addEventListener('resize', handleResize);
});
